import { client } from '../client';
import { ClientBranding } from './types/UserProfile';

/**
 * Unauthenticated — never 404s, an unknown/deleted client code returns
 * Dentistry.One's default branding rather than an error.
 */
export const getClientBranding = async (code: string): Promise<ClientBranding> => {
  const { data } = await client.get(`/clients/${code}/branding`);

  return data;
};
